<p-fieldset>
  <p-header class="article-title">
    <div class="article-title">{{ "BOAT-REGISTRATION" | translate }}</div>
  </p-header>
  <div class="content-log">
    <div>
      <label>Apreender</label>
      <label [ngClass]="{'item-new-log': isChangedApprehend() && isNew, 'item-old-log': isChangedApprehend() && !isNew}">
        {{ (getApprehend() ? 'SIM' : 'NÃO') | translate }}
      </label>
    </div>
    <div>
      <label>Tanques Independentes</label>
      <label [ngClass]="{'item-new-log': isChangedIndependentTanks() && isNew, 'item-old-log': isChangedIndependentTanks() && !isNew}">
        {{ (getIndependentTanks() ? 'SIM' : 'NÃO') | translate }}
      </label>
    </div>
    <div>
      <label>Marina Lava Meu Barco</label>
      <label [ngClass]="{'item-new-log': isChangedMarineWashMyBoat() && isNew, 'item-old-log': isChangedMarineWashMyBoat() && !isNew}">
        {{ (getMarineWashMyBoat() ? 'SIM' : 'NÃO') | translate }}
      </label>
    </div>
    <div>
      <label>Marina Liga Meu Motor</label>
      <label [ngClass]="{'item-new-log': isChangedMarineRunMyEnginer() && isNew, 'item-old-log': isChangedMarineRunMyEnginer() && !isNew}">
        {{ (getMarineRunMyEnginer() ? 'SIM' : 'NÃO') | translate }}
      </label>
    </div>
    <div>
      <label>Tempo Entre Lavagens</label>
      <label [ngClass]="{'item-new-log': isChangedTimeBetweenWash() && isNew, 'item-old-log': isChangedTimeBetweenWash() && !isNew}">
        {{ getTimeBetweenWash() }}
      </label>
    </div>
    <div>
      <label>Tempo Entre Rotação do Motor</label>
      <label [ngClass]="{'item-new-log': isChangedTimeBetweenEngineRotation() && isNew, 'item-old-log': isChangedTimeBetweenEngineRotation() && !isNew}">
        {{ getTimeBetweenEngineRotation() }}
      </label>
    </div>
    <div>
      <label>Tanque Cheio</label>
      <label [ngClass]="{'item-new-log': isChangedFullTank() && isNew, 'item-old-log': isChangedFullTank() && !isNew}">
        {{ (getFullTank() ? 'SIM' : 'NÃO') | translate }}
      </label>
    </div>
    <div>
      <label>Mostrar Todos os Dados do Cliente</label>
      <label [ngClass]="{'item-new-log': isChangedShowAllCustomerData() && isNew, 'item-old-log': isChangedShowAllCustomerData() && !isNew}">
        {{ (getShowAllCustomerData() ? 'SIM' : 'NÃO') | translate }}
      </label>
    </div>
    <div>
      <label>Sling Multi Fila</label>
      <label [ngClass]="{'item-new-log': isChangedSlingMultiQueue() && isNew, 'item-old-log': isChangedSlingMultiQueue() && !isNew}">
        {{ getSlingMultiQueue() }}
      </label>
    </div>
    <div>
      <label>{{ "STATUS" | translate }}</label>
      <label [ngClass]="{'item-new-log': isChangedActive() && isNew, 'item-old-log': isChangedActive() && !isNew}">
        {{ (getActive() ? 'ATIVO' : 'INATIVO') | translate }}
      </label>
    </div>
    <div>
      <label>{{ "MAINTENANCE" | translate }}</label>
      <label [ngClass]="{'item-new-log': isChangedMaintenance() && isNew, 'item-old-log': isChangedMaintenance() && !isNew}">
        {{ (getMaintenance() ? 'SIM' : 'NÃO') | translate }}
      </label>
    </div>
    <div>
      <label>Motor Duplo</label>
      <label [ngClass]="{'item-new-log': isChangedTwoTimeEngine() && isNew, 'item-old-log': isChangedTwoTimeEngine() && !isNew}">
        {{ (getTwoTimeEngine() ? 'SIM' : 'NÃO') | translate }}
      </label>
    </div>
    <div>
      <label>Disponível no App</label>
      <label [ngClass]="{'item-new-log': isChangedAvailableOnApp() && isNew, 'item-old-log': isChangedAvailableOnApp() && !isNew}">
        {{ (getAvailableOnApp() ? 'SIM' : 'NÃO') | translate }}
      </label>
    </div>
  </div>
</p-fieldset>
